import treebars from '@treebars/web-sdk';

// Single analytics method for the site: window.track(name, params) sends the event to
// Google Analytics (gtag) and to Treebars. The layout defines a stub that calls gtag
// right away and queues the event; this module replays the queue to Treebars and then
// takes over. Without a write key only GA is sent.
const writeKey = import.meta.env.VITE_TREEBARS_WRITE_KEY;
let treebarsReady = false;

if (writeKey) {
    try {
        treebars.init({ writeKey });
        treebarsReady = true;
    } catch (e) {
        console.warn('Treebars init failed', e);
    }
}

function sendToTreebars(name, params) {
    if (!treebarsReady) return;
    try {
        treebars.track(name, params);
    } catch (e) {
        console.warn('Treebars track failed', e);
    }
}

export function track(name, params) {
    if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
    }
    sendToTreebars(name, params);
}

// Who is on this page: identify() when the layout rendered a signed-in user, reset() when not.
// identify() is safe on every page load, and reset() does nothing for an anonymous visitor.
function syncIdentity() {
    if (!treebarsReady) return;
    try {
        const user = window.__treebarsUser;
        if (user && user.id) {
            treebars.identify(user.id, user.attributes);
            treebars.setConfigAttributes(user.attributes);
        } else {
            treebars.reset();
        }
    } catch (e) {
        console.warn('Treebars identity sync failed', e);
    }
}

syncIdentity();

const queued = window.track && window.track.q ? window.track.q : [];
window.track = track;
queued.forEach(([name, params]) => sendToTreebars(name, params));
